import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonModule, DatePipe, isPlatformBrowser } from '@angular/common';
import { EmptyPageComponent } from '../../../components/empty-page/empty-page.component';
import { CreaturesService } from '../../../../services/creatures.service';
import { CreatureLiteWebDto } from '../../../../dtos/creature.lite.web.dto';
import { RouterLink } from '@angular/router';
import { CreatureSortType } from '../../../../enums/creature-sort.type';
import { CreatureSortTypePipe } from '../../../../pipes/creature-sort-type.pipe';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CreatureBreedingWebDto } from '../../../../dtos/creature.breeding.web.dto';
import { CreatureType } from '../../../../enums/creature.type';
import { RarityType } from '../../../../enums/rarity.type';
import { RarityNamePipe } from '../../../../pipes/rarity-name.pipe';
import { BreedingOrderStatus } from '../../../../enums/breeding-order.status';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'list-creature-breeding-page',
  templateUrl: './list-creature-breeding.page.html',
  styleUrl: './list-creature-breeding.page.scss',
  imports: [
    RarityNamePipe,
    DatePipe,
    CommonModule,
    EmptyPageComponent,
    TranslateModule
  ]
})
export class ListCreatureBreedingPage implements OnInit, AfterViewInit {

  public sortType: typeof CreatureSortType = CreatureSortType;
  public lang: string | null = null;

  public breedingOrders: CreatureBreedingWebDto[] | null = null;
  public animateIn: boolean = false;

  public readonly creatureType: typeof CreatureType = CreatureType;
  public readonly rarityType: typeof RarityType = RarityType;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private readonly creaturesService: CreaturesService,
    private readonly translateService: TranslateService,
  ) {
    this.lang = this.translateService.currentLang;
    this.translateService.onLangChange.subscribe((event) => {
      this.lang = event.lang;
    })
  }

  ngOnInit(): void {
    this.onFilterChange();
  }

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      requestAnimationFrame(() => this.animateIn = true);
    }
  }

  public showLoading: boolean = false;
  onFilterChange() {
    this.showLoading = true;

    this.breedingOrders = [];

    this.creaturesService.getBreedingByFilter().subscribe({
      next: (newOrders) => {
        if (newOrders.length === 0) {
        } else {

          newOrders.sort((a, b) => {
            return new Date(b.breedingOrder.createdAt).getTime() - new Date(a.breedingOrder.createdAt).getTime();
          });

          this.breedingOrders = [...(this.breedingOrders ?? []), ...newOrders];
        }
        this.showLoading = false;
      },
      error: (err) => {
        console.error('Failed to load creatures:', err);
        this.showLoading = false;
      },
    });
  }

  getProgress(order: CreatureBreedingWebDto): number {
    if (order.breedingOrder.status === BreedingOrderStatus.Executed) {
      return 100;
    } else if (order.breedingOrder.status === BreedingOrderStatus.Cancelled) {
      return 0;
    } else if (order.breedingOrder.status === BreedingOrderStatus.Pending && order.breedingOrder.estimatedCompletionTime) {
      const createdAt = new Date(order.breedingOrder.createdAt).getTime();
      const estimatedCompletionTime = new Date(order.breedingOrder.estimatedCompletionTime).getTime();
      
      if (isNaN(createdAt) || isNaN(estimatedCompletionTime) || estimatedCompletionTime <= createdAt) {
        return 0;
      }
      
      const progress = ((Date.now() - createdAt) / (estimatedCompletionTime - createdAt)) * 100;
      return Math.min(100, Math.max(0, progress / 1000)).toFixed(2) as unknown as number;
    } else {
      return 0;
    }
  }

  getTxLink(hash: string): string {
    if (environment.blockchain === 'Sepolia Testnet') {
      return `https://sepolia.etherscan.io/tx/${hash}`;
    } else if (environment.blockchain === 'Polygon Mainnet') {
      return `https://polygonscan.com/tx/${hash}`;
    } else {
      return '#';
    }
  }
}